import { render, staticRenderFns } from "./NewMediafile.vue?vue&type=template&id=1fb745f4&scoped=true&"
import script from "./NewMediafile.vue?vue&type=script&lang=js&"
export * from "./NewMediafile.vue?vue&type=script&lang=js&"
import style0 from "./NewMediafile.vue?vue&type=style&index=0&id=1fb745f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb745f4",
  null
  
)

export default component.exports